import { Shimmer } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import styled from "styled-components"

const ProductBreadcrumb = styled.ol`
  color: ${(props) => props.theme.colors.black};
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  list-style: none;
  margin: 0 0 8px;
  padding: 0;

  li {
    display: inline;
  }

  li:last-child {
    color: ${(props) => props.theme.colors.grey[400]};
  }

  li + li:before {
    content: "/";
    padding: 0 4px;
  }

  ${(props) => props.theme.mediaQueries.tablet`
    color: ${props.theme.colors.grey[500]};
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    margin-bottom: 10px;
    li:last-child {
      color: ${props.theme.colors.grey[500]};
    }
  `}
`

const InternalBreadcrumb = ({ breadcrumb_array, wizardLoading }) => {
  if (wizardLoading) {
    return (
      <Shimmer
        height={{ _: "14px", tablet: "16px" }}
        mb={{ _: 1, tablet: "10px" }}
        width="160px"
      />
    )
  }

  return (
    <nav aria-label="Breadcrumb">
      <ProductBreadcrumb>
        {breadcrumb_array.map((breadcrumb) => (
          <li key={`breadcrumb-${breadcrumb.name}`}>
            <Link data-lc="breadcrumb" to={breadcrumb.url}>
              {breadcrumb.name}
            </Link>
          </li>
        ))}
      </ProductBreadcrumb>
    </nav>
  )
}

const mapStateToProps = (state) => {
  return {
    breadcrumb_array: state.wizard.description.breadcrumb || [],
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = () => ({})

InternalBreadcrumb.propTypes = {
  breadcrumb_array: PropTypes.array,
  wizardLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}

const Breadcrumb = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalBreadcrumb)

export default Breadcrumb
